import React from "react";
import {OrbitComponent} from "../../../base-components/orbit-component/orbit-component";
import {DropDownComponent, DropDownItem, IDropDownSelectionResult} from "./drop-down.component";
import {NullableNumber} from "../../../../../common/types/nullable-types";
import {parseCommaSeparatedNumbers} from "../../../../../utils/string-helpers";
import {observer} from "mobx-react";
import {CyClass} from "../../../../../common/cy-classes";

interface LossLimitDropDownComponentProps {
    onItemSelected: (value: NullableNumber) => void;
    errorMessage?: string;
}

export const LossLimitDropDownComponent = observer(
    class LossLimitDropDownComponent extends OrbitComponent<LossLimitDropDownComponentProps> {

        private _getLossLimits(): DropDownItem[] {
            let bankroll = this.services.walletProxy.totalBankroll;

            const translateLossLimit = (percent: number, lossAmount: number): string => {
                return this.services.translation.translate('GAMBLING_SESSION_LOSS_LIMIT_VALUE', {
                    percent: percent,
                    loss: this.services.currency.formatMoney(lossAmount)
                })
            }

            if (bankroll < 100) {
                return [
                    {
                        value: bankroll,
                        text: translateLossLimit(100, bankroll)
                    }
                ]
            }

            const percentages = parseCommaSeparatedNumbers(this.services.configuration.servicesConfigs.Regulation.Spain.LossLimitPercentages);

            return percentages.map(p => {
                return {
                    percent: p,
                    value: Math.floor(p * bankroll / 100)
                }
            }).filter(lossLimit => lossLimit.value >= 100)
                .map(lossLimit => {
                    return {
                        value: lossLimit.value,
                        text: translateLossLimit(lossLimit.percent, lossLimit.value)
                    }
                });
        }

        private _onItemSelectedHandler = async (value: NullableNumber): Promise<IDropDownSelectionResult> => {
            this.props.onItemSelected(value);
            return {
                cancel: false
            };
        }

        render() {
            return (
                <DropDownComponent label={this.services.translation.translate('GAMBLING_SESSION_LOSS_LIMIT_DROP_DOWN_LABEL')}
                                   items={this._getLossLimits()}
                                   nullItemText={this.services.translation.translate('SELECT')}
                                   onItemSelected={this._onItemSelectedHandler}
                                   errorMessage={this.props.errorMessage}
                                   className={CyClass('cy-gambling-session-limit-loss-limit-select')}/>
            );
        }
    }
);